module.exports = __webpack_public_path__ + "img/monitor.3c36bcc6.png";